import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { translate } from 'react-i18next';
import { ReduxAsyncConnect, asyncConnect, reducer as reduxAsyncConnect } from 'redux-connect';

import * as ClientActions from 'redux/modules/clients';
import { isLoaded as areModulesLoaded, load as loadModules } from 'redux/modules/modules';



import { CreateClientForm } from 'components';

@asyncConnect([{
  promise: ({ store: { dispatch, getState } }) => {
    const promises = [];
    if (!areModulesLoaded(getState())) {
      promises.push(dispatch(loadModules()));

    }
    promises.push(dispatch(ClientActions.loadCommercials()));
    return Promise.all(promises);
  }
}])
@connect(
  state => ({
    modules: state.modules.data,
    commercials: state.clients.commercials,
  })
)
@translate(['common'])
export default class AddClient extends Component {

  render() {
    const {
      t, commercials
    } = this.props;

    const styles = require('./AddClient.scss');

    return (
      <div className={'container'}>
        <Helmet title={t("main.create_client")} />
        <h1>
          {t("main.create_client")}   
        </h1>

        <CreateClientForm key="createClientForm1" coms={commercials} />
      </div>
    );
  }
}
